import { n as ok, t as err } from "./result-D_NYcfr2.js";
//#region src/validate.ts
/**
* Validate unknown input against a Zod schema.
*
* When validation fails, issues are automatically formatted into a human-readable
* message. If a `createError` factory is provided, it receives the formatted
* issues and message. Otherwise, a plain `Error` with the formatted message is
* returned.
*
* @param options - The validation options.
* @param options.schema - The Zod schema to validate against.
* @param options.params - The unknown value to validate.
* @param options.createError - Optional factory invoked when validation fails.
* @returns A Result tuple - either [Error, null] on failure or [null, T] on success.
*/
function validate({ schema, params, createError }) {
	const result = schema.safeParse(params);
	if (!result.success) {
		const formatted = formatZodIssues(result.error.issues);
		if (createError) return err(createError(formatted));
		return err(formatted.message);
	}
	return ok(result.data);
}
/**
* Format raw Zod validation issues into structured objects and a human-readable string.
*
* @private
* @param issues - Raw Zod validation issues.
* @param separator - Separator between formatted issue strings.
* @returns An object containing the formatted issues array and a joined message string.
*/
function formatZodIssues(issues, separator = "\n  ") {
	const formatted = issues.map((issue) => ({
		message: issue.message,
		path: issue.path.map(String).join(".")
	}));
	return {
		issues: formatted,
		message: formatted.map((item) => {
			if (item.path.length > 0) return `${item.path}: ${item.message}`;
			return item.message;
		}).join(separator)
	};
}
//#endregion
export { validate };

//# sourceMappingURL=validate.js.map